import { apiSlice } from "@/services/api-slice";
import { Product, CreateProduct, UpdateProduct, ProductRequest, SettingsProducts, ProductsWithLocationsResponse, ProductSearch, CreateProductoLocation, ProductoLocation, LocationsDataProduct, ProductUbicationsRequest, SettingsInputsProducts, AdjustmentRequest, LocationStockUpdatedResponse, TransferRequest, ProductSharedView, ProductSharedViewRequest, ProductVisibilityRestriction, ProductVisibilityRestrictionRequest, CreateProductVisibilityRestriction, ProductUbicationsSettingsRequest } from "./materials.interface";
import { APIResponse } from "@/types/custom-http";


export const productsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      // Obtener todos los usuarios
      getProducts: builder.query<APIResponse<{page: number; size: number; total: number; totalPages: number; productos: Product[]}>, ProductRequest>({
        query: (params) => {
          const finalParams: ProductRequest = {
            page: params.page,
            size: params.size,
          };

          if (params.showAll !== undefined) {
            finalParams.showAll = params.showAll;
          }

          if (params.search) {
            finalParams.search = params.search;
          }

          if (params.categoria_id) {
            finalParams.categoria_id = params.categoria_id;
          }

          if (params.subcategoria_id) {
            finalParams.subcategoria_id = params.subcategoria_id;
          }

          if (params.include_private !== undefined) {
            finalParams.include_private = params.include_private;
          }

          if (params.bypass_visibility !== undefined) {
            finalParams.bypass_visibility = params.bypass_visibility;
          }

          return {
            url: "auth/warehouse/products",
            params: finalParams,
          };
        },
        providesTags: ["Product"],
      }),

      getProductsSharedView: builder.query<APIResponse<{page: number; size: number; total: number; totalPages: number; productos: ProductSharedView[]}>, ProductSharedViewRequest>({
        query: (params) => {
          const finalParams: ProductSharedViewRequest = {
            page: params.page,
            size: params.size,
          };

          if (params.search) {
            finalParams.search = params.search;
          }

          if (params.categoria_id) {
            finalParams.categoria_id = params.categoria_id;
          }

          if (params.subcategoria_id) {
            finalParams.subcategoria_id = params.subcategoria_id;
          }

          return {
            url: "auth/warehouse/products/shared-view",
            params: finalParams,
          };
        },
        providesTags: ["Product"],
      }),

      
      // Obtener un material por ID
      getProductsById: builder.query<APIResponse<Product>, number>({
        query: (id) => ({ url:`auth/warehouse/products/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'Product', id }],
      }),

      // Obtener configuraciones de productos
      getSettingsProducts: builder.query<APIResponse<SettingsProducts>, void>({
        query: () => ({ url:`auth/warehouse/products/settings`}),
        providesTags: ["Catalogue"],
      }),
      
      // Crear un nuevo material
      createProducts: builder.mutation<APIResponse<Product>, CreateProduct>({
        query: (user) => ({
          url: 'auth/warehouse/products',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['Product'],
      }),
      
      // Actualizar un material existente
      updateProducts: builder.mutation<APIResponse<Product>, { id: number; changes: UpdateProduct }>({
        query: ({ id, changes }) => ({
          url: `auth/warehouse/products/${id}`,
          method: 'PATCH',
          body: changes,
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'Product', id },'Product'],
      }),
      
      // Eliminar un material
      deleteProducts: builder.mutation<APIResponse<null>, number>({
        query: (id) => ({
          url: `auth/warehouse/products/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Product'],
      }),

      // Obtener configuraciones de productos
      getProductsUbications: builder.query<APIResponse<ProductsWithLocationsResponse>, ProductRequest>({
        query: (params) => {
          const finalParams: ProductRequest = {
            page: params.page,
            size: params.size,
          };

          if (params.showAll !== undefined) {
            finalParams.showAll = params.showAll;
          }

          if (params.search) {
            finalParams.search = params.search;
          }

          if (params.categoria_id) {
            finalParams.categoria_id = params.categoria_id;
          }

          if (params.subcategoria_id) {
            finalParams.subcategoria_id = params.subcategoria_id;
          }

          if (params.stock_scope) {
            finalParams.stock_scope = params.stock_scope;
          }

          return {
            url: "auth/warehouse/product-location",
            params: finalParams,
          };
        },
        providesTags: ["Product"],
      }),

      getProductVisibilityRestrictions: builder.query<APIResponse<ProductVisibilityRestriction[]>, ProductVisibilityRestrictionRequest | void>({
        query: (params) => ({
          url: "auth/warehouse/products/visibility",
          params: params ?? undefined,
        }),
        providesTags: ["Product"],
      }),

      createProductVisibilityRestriction: builder.mutation<APIResponse<ProductVisibilityRestriction>, CreateProductVisibilityRestriction>({
        query: (body) => ({
          url: "auth/warehouse/products/visibility",
          method: "POST",
          body,
        }),
        invalidatesTags: ["Product"],
      }),

      deleteProductVisibilityRestriction: builder.mutation<APIResponse<ProductVisibilityRestriction>, { product_id: number; company_id: number }>({
        query: ({ product_id, company_id }) => ({
          url: `auth/warehouse/products/visibility/${product_id}/company/${company_id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Product"],
      }),


      // Obtener Configuraciones para la Recepción de Mercadería
      getProductUbicationsSettings: builder.query<APIResponse<SettingsInputsProducts>, ProductUbicationsSettingsRequest | void>({
        query: (params) => ({
          url: 'auth/warehouse/product-location/settings',
          method: 'GET',
          params: params ?? undefined,
        }),
        providesTags: ["ProductUbicationSettings"],
      }),

      // Obtener ubicaciones de un producto
      getProductUbicationsByProductId: builder.query<APIResponse<LocationsDataProduct[]>, ProductUbicationsRequest>({
        query: (body) => ({
          url: 'auth/warehouse/product-location/ubications',
          method: 'POST',
          body: body,
        }),
        providesTags: ["Product"],
      }),


      // Generar Ajuste de Inventario a la Ubicación de un Producto
      generateAdjustmentStock: builder.mutation<APIResponse<{success: boolean, operation: string, ubication: LocationStockUpdatedResponse}>, AdjustmentRequest>({
        query: (body) => ({
          url: 'auth/warehouse/product-location/adjustment',
          method: 'POST',
          body: body,
        }),
        invalidatesTags: ["Product"],
      }),

      // Generar Transferencia de Stock a la Ubicación de un Producto
      generateTransferStock: builder.mutation<APIResponse<{success: boolean, operation: string, ubication: LocationStockUpdatedResponse}>, TransferRequest>({
        query: (body) => ({
          url: 'auth/warehouse/product-location/transfer',
          method: 'POST',
          body: body,
        }),
        invalidatesTags: ["Product"],
      }),

      // Crear un nuevo usuario
      createProductLocation: builder.mutation<APIResponse<ProductoLocation>, CreateProductoLocation>({
        query: (user) => ({
          url: 'auth/warehouse/product-location',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['Product'],
      }),

      // Buscar productos
      searchProducts: builder.query<APIResponse<ProductSearch[]>, string>({
        query: (search) => ({
          url: `auth/warehouse/products/search`,
          params: { search },
        }),
        providesTags: ["Product"],
      })

    }),
  });
  
  export const {
    useGetProductsQuery,
    useLazyGetProductsQuery,
    useGetProductsSharedViewQuery,
    useLazyGetProductsSharedViewQuery,
    useGetSettingsProductsQuery,
    useUpdateProductsMutation,
    useCreateProductsMutation,
    useDeleteProductsMutation,
    useGetProductsUbicationsQuery,
    useLazyGetProductsUbicationsQuery,
    useGetProductUbicationsByProductIdQuery,
    useGetProductUbicationsSettingsQuery,
    useLazyGetProductUbicationsByProductIdQuery,
    useCreateProductLocationMutation,
    useGenerateAdjustmentStockMutation,
    useGenerateTransferStockMutation,
    useGetProductVisibilityRestrictionsQuery,
    useLazyGetProductVisibilityRestrictionsQuery,
    useCreateProductVisibilityRestrictionMutation,
    useDeleteProductVisibilityRestrictionMutation,
    useSearchProductsQuery,
    useLazySearchProductsQuery
  } = productsApi;
